import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { PayloadFindRequestParams } from '../services/api/api.types'
import { getParamsWithDefaults } from '../utils/payloadHelpers'
import { useGlobalState } from './useGlobalState'

export function useUsersQuery(opts?: { params?: PayloadFindRequestParams }) {
  const params = getParamsWithDefaults(opts?.params, { sort: 'lastName,firstName' })

  const { api } = useGlobalState()

  return useQuery({
    queryKey: ['users', params],
    queryFn: () => api.getUsers(params),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 10,
  })
}

export function useUserQuery(opts: { params: { id: string | null } }) {
  const { params } = opts

  const { api } = useGlobalState()

  return useQuery({
    queryKey: ['users', params],
    queryFn: () => api.getUser({ id: params.id! }),
    staleTime: 1000 * 10,
    enabled: !!params.id,
  })
}
